/**
 * Returns focus to `trigger` only if it was lost: nothing holds it, or the element holding it sits
 * inside one of `roots`, the shells that just closed. Focus a parent has already moved elsewhere,
 * into another shell it opened in the same switch, is left where it is.
 *
 * @param {Element} trigger whatever held focus when the closing component opened
 * @param {Array<Element>} roots root elements of the closing component's shells
 */
export function restoreFocusIfLost(trigger, roots) {
  if (!trigger?.isConnected) return;

  let active = document.activeElement;
  let isLost = !active || active === document.body || roots.some(root => root?.contains(active));

  if (isLost) trigger.focus({ preventScroll: true });
}
